export const UserRole = Object.freeze({
  // customer
  END_USER: 'end_user',
  // user
  AGENT: 'agent',
  TEAM_LEADER: 'team_leader',
  SUPERVISOR: 'supervisor',
  ADMINISTRATOR: 'administrator',
})

export const UserRoleContext = Object.freeze({
  // customer
  [UserRole.END_USER]: 'Khách hàng',
  // user
  [UserRole.AGENT]: 'Chuyên viên',
  [UserRole.TEAM_LEADER]: 'Trưởng bộ phận',
  [UserRole.SUPERVISOR]: 'Supervisor',
  [UserRole.ADMINISTRATOR]: 'Administrator',
})

export const UserAvailableStatus = Object.freeze({
  AVAILABLE: 'AVAILABLE',
  NOT_AVAILABLE: 'NOT AVAILABLE',
  NO_ACD: 'NOACD',
  ON_CAMPAIGN: 'ONCAMPAIGN',
  TYPING: 'TYPING',
  AT_LUNCH: 'ATLUNCH',
  MEETING: 'MEETING',
  TRAINING: 'TRAINING',
  GO_OUT: 'GOOUT',
  LOGOUT: 'LOGOUT',
})

export const UserAvailableStatusContext = Object.freeze({
  [UserAvailableStatus.AVAILABLE]: 'Sẵn sàng làm việc',
  [UserAvailableStatus.NOT_AVAILABLE]: 'Không sẵn sàng làm việc',
  [UserAvailableStatus.NO_ACD]: 'Sẵn sàng NoACD',
  [UserAvailableStatus.ON_CAMPAIGN]: 'Thực hiện chiến dịch',
  [UserAvailableStatus.TYPING]: 'Typing',
  [UserAvailableStatus.AT_LUNCH]: 'Ăn trưa',
  [UserAvailableStatus.MEETING]: 'Đi họp',
  [UserAvailableStatus.TRAINING]: 'Đào tạo',
  [UserAvailableStatus.GO_OUT]: 'Đi ra ngoài',
  [UserAvailableStatus.LOGOUT]: 'Đăng xuất',
})

export const UserAvailableStatusStatusColor = {
  [UserAvailableStatus.AVAILABLE]: 'bg-[--label-green-prime]',
  [UserAvailableStatus.NOT_AVAILABLE]: 'bg-[--label-red-foreground]',
  [UserAvailableStatus.NO_ACD]: 'bg-[--label-orange-foreground]',
  [UserAvailableStatus.ON_CAMPAIGN]: 'bg-[--label-blue-foreground]',
  [UserAvailableStatus.TYPING]: 'bg-gray-400',
  [UserAvailableStatus.AT_LUNCH]: 'bg-gray-400',
  [UserAvailableStatus.MEETING]: 'bg-gray-400',
  [UserAvailableStatus.TRAINING]: 'bg-gray-400',
  [UserAvailableStatus.GO_OUT]: 'bg-gray-400',
}

export const CustomerType = Object.freeze({
  ECONOMY: '0',
  SILVER: '1',
  GOLD: '2',
  DIAMOND: '3',
})

export const CustomerTypeContext = Object.freeze({
  [CustomerType.ECONOMY]: 'Thường',
  [CustomerType.SILVER]: 'Bạc',
  [CustomerType.GOLD]: 'Vàng',
  [CustomerType.DIAMOND]: 'Kim cương',
})

export const UserGroup = Object.freeze({
  USER: 'user',
  END_USER: 'end_user',
})

export const SourceUser = Object.freeze({
  WEB: 'web',
  CALL_IN: 'CALL_INBOUND',
  CALL_OUT: 'CALL_OUTBOUND',
  CALL: 'call',
  CHAT: 'chat',
  ZALO: 'zalo',
  FACEBOOK: 'facebook',
  EMAIL: 'email',
  HAND: 'hand',
  API: 'api',
  IMPORT: 'import',
  WHATSAPP: 'whatsapp',
})

export const SourceUserContext = Object.freeze({
  [SourceUser.WEB]: 'Livechat',
  [SourceUser.CALL_OUT]: 'Gọi ra',
  [SourceUser.CALL_IN]: 'Gọi vào',
  [SourceUser.CHAT]: 'Livechat',
  [SourceUser.ZALO]: 'Zalo',
  [SourceUser.FACEBOOK]: 'Facebook',
  [SourceUser.EMAIL]: 'Email',
  [SourceUser.HAND]: 'Thủ công',
  [SourceUser.API]: 'Từ CRM',
  [SourceUser.IMPORT]: 'Import',
  [SourceUser.WHATSAPP]: 'WhatsApp',
})

export const CustomerAssign = Object.freeze({
  ALL: 'all',
  MyOrganization: 'my_organization',
  MyGroup: 'my_group',
  MyCustomer: 'me',
})

export const Gender = Object.freeze({
  MALE: 'male',
  FEMALE: 'female',
  OTHER: 'other',
})

export const GenderContext = Object.freeze({
  [Gender.MALE]: 'Nam',
  [Gender.FEMALE]: 'Nữ',
  [Gender.OTHER]: 'Khác',
})

export const UseRoleOptions = [
  { id: UserRole.AGENT, text: UserRoleContext[UserRole.AGENT] },
  { id: UserRole.TEAM_LEADER, text: UserRoleContext[UserRole.TEAM_LEADER] },
  { id: UserRole.SUPERVISOR, text: UserRoleContext[UserRole.SUPERVISOR] },
  { id: UserRole.ADMINISTRATOR, text: UserRoleContext[UserRole.ADMINISTRATOR] },
]

export const GenderOptions = [
  { id: Gender.MALE, text: GenderContext[Gender.MALE] },
  { id: Gender.FEMALE, text: GenderContext[Gender.FEMALE] },
  { id: Gender.OTHER, text: GenderContext[Gender.OTHER] },
]
